
import { Component, Prop, Vue } from 'vue-property-decorator'
import { getFinanceAuthority, getAvoidLoginUrl } from "@/api/iousServices";
import { jump2Quota, toQuotaResDto } from '@/api/customerManage';
import { updateUserOtherInfoFCD } from '@/api/commonConfig';
import { openNewPage } from '@/utils/h5ToApp';
import { Getter, Action } from "vuex-class";

@Component
export default class supplementaryPayBtn extends Vue {
  @Prop({ default: '' }) companyId?: string
  @Prop({ default: '' }) orderId?: string
  @Prop({ default: '' }) orderMoney?: any //总金额
  @Prop({ default: '' }) playMoney?: any //已付款金额
  @Prop({ default: '' }) storeId?: any //店铺id
  @Prop({ default: 0 }) itemIndex?: number // 当前数据在数组中的位置
  @Action setWhiteStrips!: (val: string) => void
  @Getter whiteStrips!: number
  @Getter userId!: string
  @Getter mobile!: string

  // whiteStrips!: number
  countMoney: any

  created() {
    // this.getAuthority()
    console.log('created=',this.whiteStrips);
    this.countMoney = this.orderMoney - this.playMoney
    // console.log('计算未付款金额=',this.countMoney);
    // this.fdfreeLogin()
    // this.sureFunc()
  }

  // 1还款入口 2授信入口 3借款入口
  fdfreeLogin(flag = '3') {
    let params = {
      companyId: this.companyId,
      orderId: this.orderId,
      tradeMoney: this.orderMoney,
      webShow: flag
    }
    getAvoidLoginUrl({...params}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        let encodeUrl = encodeURI(data.redirectUrl)
        let url = `${encodeUrl}?webShow=${flag}&userPhone=${this.mobile}`
        openNewPage({url})
        console.log('getAvoidLoginUrl=',res);
      }
    })
  }

  getAuthority() {
    console.log('调用了啊================')
    getFinanceAuthority({companyId: this.companyId}).then((res) =>{
      const { code, data } = res
      if( code === "000000" ) {
        this.setWhiteStrips(data.whiteStrips)
      }
      console.log('getFinanceAuthority=',res);
    })
  }

  // goCashier() {
  //   console.log('whiteStrips=',this.whiteStrips);
  //   switch (this.whiteStrips) {
  //     case 1:
  //     case 4:
  //     case 5:
  //       this.$router.push({ path: '/iousServices', query: { orderId: this.orderId, orderMoney: this.countMoney, storeId:this.storeId } })
  //       break;
  //     case 2:
  //       this.$dialog.confirm({
  //         message: '当前企业未完成企业认证，暂时无法使用支付功能',
  //         confirmButtonText: '去认证',
  //         cancelButtonText: '取消支付'
  //       }).then(() => {
  //         window.localStorage.removeItem('isFinance')
  //         // 白条需求支付标识，用于人脸识别使用
  //         window.localStorage.setItem('FDWhite','1')
  //         window.localStorage.setItem('orderId',this.orderId)
  //         this.$router.push({
  //           path: '/companyInfoForm',
  //           query: {
  //             formPage: 'h5'

  //           }
  //         })
  //       }).catch(() => {
  //         // this.$router.push('/purchaseOrderList')
  //       })
  //       break;
  //     case 3:
  //       this.$dialog.confirm({
  //         message: '当前账号未完成身份认证，暂时无法使用支付功能',
  //         confirmButtonText: '去认证',
  //         cancelButtonText: '取消支付'
  //       }).then(() => {
  //         window.localStorage.removeItem('isFinance')
  //         // 白条需求支付标识，用于人脸识别使用
  //         window.localStorage.setItem('FDWhite','1')
  //         window.localStorage.setItem('orderId',this.orderId)
  //         this.$router.push({
  //           path: '/userInfoForm',
  //           query: {
  //             formPage: 'h5'
  //           }
  //         })
  //       }).catch(() => {
  //         // this.$router.push('/purchaseOrderList')
  //       })
  //       break;
  //   }
  // }

  goCashier() {
    this.$emit('click', this.itemIndex)
    window.localStorage.setItem('orderId',this.orderId)
    // type 1 候补支付
    this.$router.push({ path: '/iousServices', query: { orderId: this.orderId, orderMoney: this.countMoney, storeId:this.storeId, type:'1'  } })
  }

  sureFunc () {
    //  跳转个人信息使用授权书页面
    updateUserOtherInfoFCD({userId:this.userId}).then((res)=>{
      if(res.code==='000000'){
        this.$router.push({
          path: '/financialServices',
        })
      }else {
        this.$toast('个人信息授权失败')
      }
    })
  }

  /**
   * 去出额
   * @param isAuthorized 是否授权，默认false
   */
  toQuota () {
    const obj = {
      companyId: this.companyId,
      merchantId: '66666666666'
      // isAuthorized: true
    }
    jump2Quota(obj).then((res) => {
      if (res.code === '000000') {
        //    跳转到免登录产融h5
        this.toFreeLogin(res.data)
      }
    })
  }

  /**
   * 跳转到免登录页面
   * @param data 后端接口返回数据
   */
  toFreeLogin (data: toQuotaResDto) {
    // let redirectUrl = 'http://172.16.101.69:8088/#/loginFree?as=CYTCS001&cs=1000&orderId=24b3bf8c-1570-455f-9da8-7b33efe62283&client=0&industryType='
    openNewPage({url: encodeURI(data.redirectUrl)})
  }
}
